// @figma file=pkCGby54zXzTsccXvHqzO6 node=tbd name="DatePickerInput" set="mytaible-shadcn-studio" verified=tbd

import { format } from 'date-fns';
import { CalendarIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { Button } from '../../atoms/button';
import { Calendar } from '../../molecules/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../molecules/popover';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface DatePickerInputProps {
  date?: Date;
  onDateChange?: (date: Date | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

// ─── DatePickerInput ──────────────────────────────────────────────────────────

const DatePickerInput = React.forwardRef<HTMLButtonElement, DatePickerInputProps>(
  ({ date, onDateChange, placeholder = 'Pick a date', disabled, className }, ref) => {
    const [open, setOpen] = React.useState(false);

    return (
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            ref={ref}
            variant="secondary"
            appearance="outline"
            disabled={disabled}
            className={cn(
              'w-60 justify-start text-left font-normal',
              !date && 'text-muted-foreground',
              className,
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" aria-hidden="true" />
            {date ? format(date, 'PPP') : <span>{placeholder}</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" aria-label="Date picker">
          <Calendar
            mode="single"
            selected={date}
            onSelect={(selectedDate) => {
              onDateChange?.(selectedDate);
              setOpen(false);
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    );
  },
);
DatePickerInput.displayName = 'DatePickerInput';

export { DatePickerInput };
